import lang from '@/lang'
import request from '@/modules/base/util/request'
import config from '@/modules/settings/config'
import { CHART_OF_ACCOUNT_SKR_TYPE } from '@/modules/settings/components/tax-settings/chart-of-accounts/constants'

const getTenantSettings = async() => {
  return request(config.getTenantSetting, { auth: true, isConcurrent: true })
    .then((result) => result?.body?.data || null)
}

export const ChartOfAccountsSkrTypeService = {
  getSkrTypeOptions: async() => {
    const optionMessages = lang.settings.taxes.chartsOfAccountsSkrType.options || {}

    const settings = await getTenantSettings()
    const skrOptions = settings?.availableSkrTypes || []
    return skrOptions.map((skrType) => {
      const messageInfo = optionMessages[skrType] || null
      if (!messageInfo) {
        return null
      }

      return {
        type: skrType,
        caption: messageInfo.caption || '',
      }
    }).filter(Boolean)
  },
  getCurrentTenantSkrType: async() => {
    const settings = await getTenantSettings()
    return settings?.currentSkrType || CHART_OF_ACCOUNT_SKR_TYPE.unknown
  },
  updateTenantSkrType: async(skrType) => {
    return request(config.updateTenantSkrType, { auth: true, isConcurrent: true, method: 'put', data: { skrType } })
  },
}
